import axios from 'axios';
import {
	GOOGLE_DATA_SPREADSHEET_ID,
	GOOGLE_LANGUAGES_SPREADSHEET_ID,
	DEFAULT_LANG,
	CACHE_LIFETIME
} from './Config';
import { isDevMode } from './Helpers';

export const getEndpointUrl = (endpoint) => {
	let devModeCheck = isDevMode();
	let hostname = devModeCheck ? `//localhost:4090` : ``;
	let postfix = devModeCheck ? `` : '/api/shared';
	return `${hostname}${postfix}/${endpoint}`;
}

export const getTranslation = () => {
	return new Promise(async (resolve) => {
		const mapUrl = getEndpointUrl('gsheet-data');
		const results = await axios.post(mapUrl, {
			cache: CACHE_LIFETIME,
			id: GOOGLE_LANGUAGES_SPREADSHEET_ID,
			sheet: 'UI'
		});
		resolve(results.data);
	});
}

export const getData = (optionalLang) => {
	return new Promise(async (resolve) => {
		const gsheetDataUrl = getEndpointUrl('gsheet-data');

		// main data
		let sheet = (optionalLang && optionalLang !== DEFAULT_LANG) ? optionalLang : null;
		const mainResults = await axios.post(gsheetDataUrl, {
			cache: CACHE_LIFETIME,
			id: GOOGLE_DATA_SPREADSHEET_ID,
			sheet: `types,data${sheet ? `,${sheet}` : ''}`
		});

		resolve(mainResults.data);
	});
}
